import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const HtmlContentFromApi = styled.div`
    display: block;
    word-break: break-word;
    
    ul, ol {
        display: list-item;
    }
    
    ul {
        list-style: disc;
    }
    
    ol {
        list-style: decimal;
    }
    
    h1 {
        ${FONTS.H2};

        @media (min-width: ${wideBreakpoints.mobile}) {
            ${FONTS.H0}
        }
    }

    h2 {
        ${FONTS.H3};
            
        @media (min-width: ${wideBreakpoints.mobile}) {
            ${FONTS.H1}
        }
    }

    h3 {
        ${FONTS.H4};

        @media (min-width: ${wideBreakpoints.mobile}) {
            ${FONTS.H3}
        }
    }

    h4 {
        ${FONTS.H5};

        @media (min-width: ${wideBreakpoints.mobile}) {
            ${FONTS.H4}
        }
    }

    h5, h6 {
        ${FONTS.H6};
    }
    
    p, li {
        ${FONTS.XS};
        
        b {
            ${FONTS.MediumXS};
        }

        @media (min-width: ${wideBreakpoints.mobile}) {
            b {
                ${FONTS.MediumS};
            }
        }
        
        @media (min-width: ${wideBreakpoints.mobile}) {
            ${FONTS.S};
        }
    }
    
    a {
        color: ${COLORS.Link}
    }
    
    img {
        max-width: 100%;
        height: auto;
        object-fit: contain;
    }
`;
